let database;
export const freshState = () => ({cache:{},tickets:{},outbox:[],sequence:0,lastSync:null,receivedLan:{},lanPackets:{},audit:[]});
function open() {
  if (!database) database = new Promise((resolve,reject) => {
    const r=indexedDB.open('gestion-total-pos-v1',1);
    r.onupgradeneeded=()=>r.result.createObjectStore('scopes');
    r.onsuccess=()=>{ r.result.onversionchange=()=>{r.result.close();database=null;}; resolve(r.result); };
    r.onerror=()=>{database=null;reject(r.error);};
  });
  return database;
}
export async function readState(scope) {
  const db=await open();
  return new Promise((resolve,reject)=>{ const r=db.transaction('scopes').objectStore('scopes').get(scope); r.onsuccess=()=>resolve(r.result||freshState());r.onerror=()=>reject(r.error); });
}
// The entire sale + outbox commit in ONE IndexedDB transaction, also across tabs.
// Callback must be synchronous: never await network calls inside the transaction.
export async function changeState(scope,change) {
  const db=await open();
  return new Promise((resolve,reject)=>{
    const tx=db.transaction('scopes','readwrite'); const store=tx.objectStore('scopes'); let value,failure;
    const r=store.get(scope);
    r.onsuccess=()=>{ try { const state=r.result||freshState();value=change(state);store.put(state,scope); } catch(e) {failure=e;tx.abort();} };
    tx.oncomplete=()=>resolve(value);tx.onerror=()=>reject(failure||tx.error);tx.onabort=()=>reject(failure||tx.error||new Error('No se pudo guardar en el dispositivo.'));
  });
}
